import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/config/store';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import { Route } from 'react-router-dom';
import CaseFormWrapper from 'app/edozvola/cases/case-form-wrapper';
import Cases from 'app/edozvola/cases/cases';
import ParticleArrangementForm from 'app/edozvola/cases/particle-arrangement/particle-arrangement-form';
import PlannedDocumentationForm from 'app/edozvola/cases/planned-documentation/planned-documentation-form';
import CaseTabNotImplemented from 'app/shared/error/case-tab-not-implemented';
import PreviousDocuments from 'app/edozvola/cases/previous-documents/previous-documents';
import CaseAttachment from 'app/edozvola/cases/case-attachment/case-attachment';
import CaseFinalActOtherInfoForm
  from 'app/edozvola/cases/case-final-act-other-info-form/case-final-act-other-info-form';
import CaseAuthorityForm from 'app/edozvola/cases/case-authority-form/case-authority-form';
import CaseModeratorsForm from 'app/edozvola/cases/case-moderators-form/case-moderators-form';
import CaseExecutabilityValidityForm
  from 'app/edozvola/cases/case-executability-validity-form/case-executability-validity-form';
import CaseArchiveForm from 'app/edozvola/cases/case-archive-form/case-archive-form';
import CaseAdministrativeFeeForm from 'app/edozvola/cases/case-administrative-fee-form/case-administrative-fee-form';
import CaseRequestInfoForm from 'app/edozvola/cases/case-request-info-form/case-request-info-form';
import AttachmentPageForm from 'app/edozvola/cases/request-attachments/request-attachment-page';
import CreateNewAttachment from 'app/edozvola/cases/request-attachments/create-new-request-attachment';
import CaseApplicant from 'app/edozvola/cases/case-applicant/case-applicant';
import CaseFinalDocumentForm from 'app/edozvola/cases/case-final-document/case-final-document';
import CaseAppealForm from 'app/edozvola/cases/case-appeal/case-appeal-form';
import ProjectDocuments from 'app/edozvola/cases/project-documents/project-documents';
import RequestAdmission from 'app/edozvola/cases/request-admission/request-admission';
import FinalDocumentAdmission from 'app/edozvola/cases/final-document-admission/final-document-admission';
import CaseBuildingPlotForm from 'app/edozvola/cases/case-building-plot/case-building-plot-form';
import CaseConstructionLegalityForm
  from 'app/edozvola/cases/case-construction-legality/case-construction-legality-form';
import ConstructionBuildingProcedure from './construction-building-procedure/construction-building-procedure';
import Parties from 'app/edozvola/cases/parties/parties';
import CaseMainProjectDocuments from 'app/edozvola/cases/case-main-project-documents/case-main-project-documents';
import AddedPerson from 'app/edozvola/cases/added-person/added-person';
import SpecialBuildingPart from 'app/edozvola/cases/special-building-part/special-building-part';
import LocationPermitCompliance from 'app/edozvola/cases/location-permit-compliance/location-permit-compliance';
import CaseLegalRemedyForm from 'app/edozvola/cases/case-legal-remedy-form/case-legal-remedy-form';
import CaseTechnicalInspection from 'app/edozvola/cases/case-technical-inspection/case-technical-inspection';
import ConstructionFee from './construction-fee/construction-fee';
import FiledLawsuit from 'app/edozvola/cases/filed-lawsuit/filed-lawsuit';
import CaseSegment from 'app/edozvola/cases/case-segment/case-segment';
import DeliveryOrder from 'app/edozvola/cases/delivery-order/delivery-order';
import PhasedConstructionMain from './phased-construction/phased-construction-main';
import SpecialRegulationsCompliance from './special-regulations-compliance/special-regulations-compliance';
import ConstructionParticipants from 'app/edozvola/cases/construction-participants/construction-participants';
import CaseLocation from 'app/edozvola/cases/case-location/case-location';
import CaseActs from './case-acts/case-acts';
import CaseZoningPlanCompliance from 'app/edozvola/cases/case-zoning-plan-compliance/case-zoning-plan-compliance';
import CaseCaseRegistry from 'app/edozvola/cases/case-case-registry-form/case-case-registry';
import CaseRevision from 'app/edozvola/cases/case-revision/case-revision';
import RouterPreloadData from 'app/shared/router-preload-data/router-preload-data';
import { fetchMainProjectDocumentVariantQuery } from 'app/edozvola/cases/case-main-project-documents/service/case-main-project-documents.queries';
import AmendmentActs from './case-acts/amendment-acts';
import {
  fetchProjectDocumentVariantQuery
} from 'app/edozvola/cases/project-documents/service/project-document.queries';
import { fetchApplicantsVariantQuery } from 'app/edozvola/cases/case-applicant/service/case-applicant.queries';
import {
  fetchConstructionBuildingProcedureVariantQuery
} from 'app/edozvola/cases/construction-building-procedure/service/construction-building-procedure.queries';
import { getCaseRegistryVariantQuery } from 'app/edozvola/cases/case-case-registry-form/service/case-registry.queries';

const CasesRoutes = () => {
  return (
    <ErrorBoundaryRoutes>
      <Route path=":id">
        <Route index element={<CaseFormWrapper children={null} />} />
        <Route
          path="acts"
          element={
            <CaseFormWrapper>
              <CaseActs />
            </CaseFormWrapper>
          }
        />
        <Route
          path="amendment-acts"
          element={
            <CaseFormWrapper>
              <AmendmentActs />
            </CaseFormWrapper>
          }
        />
        <Route
          path="authority"
          element={
            <CaseFormWrapper>
              <CaseAuthorityForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="moderators"
          element={
            <CaseFormWrapper>
              <CaseModeratorsForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="case-registry"
          element={
            <CaseFormWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => getCaseRegistryVariantQuery(uuid, false)}>
                <CaseCaseRegistry />
              </RouterPreloadData>
            </CaseFormWrapper>
          }
        />
        <Route
          path="request-admission"
          element={
            <CaseFormWrapper>
              <RequestAdmission />
            </CaseFormWrapper>
          }
        />
        <Route
          path="request-info"
          element={
            <CaseFormWrapper>
              <CaseRequestInfoForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="final-document-act"
          element={
            <CaseFormWrapper>
              <CaseFinalDocumentForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="appeal"
          element={
            <CaseFormWrapper>
              <CaseAppealForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="executability-validity"
          element={
            <CaseFormWrapper>
              <CaseExecutabilityValidityForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="archive"
          element={
            <CaseFormWrapper>
              <CaseArchiveForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="administrative-fee"
          element={
            <CaseFormWrapper>
              <CaseAdministrativeFeeForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="legal-remedy"
          element={
            <CaseFormWrapper>
              <CaseLegalRemedyForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="building-plot"
          element={
            <CaseFormWrapper>
              <CaseBuildingPlotForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="construction-legality"
          element={
            <CaseFormWrapper>
              <CaseConstructionLegalityForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="phased-construction"
          element={
            <CaseFormWrapper>
              <PhasedConstructionMain />
            </CaseFormWrapper>
          }
        />
        <Route
          path="request-attachments"
          element={
            <CaseFormWrapper>
              <CaseAttachment />
            </CaseFormWrapper>
          }
        />
        <Route
          path="previous-documents"
          element={
            <CaseFormWrapper>
              <PreviousDocuments />
            </CaseFormWrapper>
          }
        />
        <Route
          path="project-documents"
          element={
            <CaseFormWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchProjectDocumentVariantQuery(uuid, false)}>
                <ProjectDocuments />
              </RouterPreloadData>
            </CaseFormWrapper>
          }
        />
        <Route
          path="main-project-documents"
          element={
            <CaseFormWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchMainProjectDocumentVariantQuery(uuid, false)}>
                <CaseMainProjectDocuments />
              </RouterPreloadData>
            </CaseFormWrapper>
          }
        />
        <Route
          path="applicants"
          element={
            <CaseFormWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchApplicantsVariantQuery(uuid, false)}>
                <CaseApplicant />
              </RouterPreloadData>
            </CaseFormWrapper>
          }
        />
        <Route
          path="final-document-admission"
          element={
            <CaseFormWrapper>
              <FinalDocumentAdmission />
            </CaseFormWrapper>
          }
        />
        <Route
          path="attachments/:idAttachment"
          element={
            <CaseFormWrapper>
              <CreateNewAttachment />
            </CaseFormWrapper>
          }
        />
        <Route
          path="construction-building-procedure"
          element={
            <CaseFormWrapper>
              <RouterPreloadData loaderFunction={(uuid: string) => fetchConstructionBuildingProcedureVariantQuery(uuid, false)}>
                <ConstructionBuildingProcedure />
              </RouterPreloadData>
            </CaseFormWrapper>
          }
        />
        <Route
          path="construction-participants"
          element={
            <CaseFormWrapper>
              <ConstructionParticipants />
            </CaseFormWrapper>
          }
        />
        <Route
          path="location"
          element={
            <CaseFormWrapper>
              <CaseLocation />
            </CaseFormWrapper>
          }
        />
        <Route
          path="parties"
          element={
            <CaseFormWrapper>
              <Parties />
            </CaseFormWrapper>
          }
        />
        <Route
          path="added-person"
          element={
            <CaseFormWrapper>
              <AddedPerson />
            </CaseFormWrapper>
          }
        />
        <Route
          path="special-building-part"
          element={
            <CaseFormWrapper>
              <SpecialBuildingPart />
            </CaseFormWrapper>
          }
        />
        <Route
          path="location-permit-compliance"
          element={
            <CaseFormWrapper>
              <LocationPermitCompliance />
            </CaseFormWrapper>
          }
        />
        <Route
          path="final-document-admission"
          element={
            <CaseFormWrapper>
              <FinalDocumentAdmission />
            </CaseFormWrapper>
          }
        />
        <Route
          path="particle-arrangement"
          element={
            <CaseFormWrapper>
              <ParticleArrangementForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="planned-documentation"
          element={
            <CaseFormWrapper>
              <PlannedDocumentationForm />
            </CaseFormWrapper>
          }
        />
        <Route
          path="technical-inspection"
          element={
            <CaseFormWrapper>
              <CaseTechnicalInspection />
            </CaseFormWrapper>
          }
        />
        <Route
          path="construction-administrative-fee"
          element={
            <CaseFormWrapper>
              <ConstructionFee />
            </CaseFormWrapper>
          }
        />
        <Route
          path="filed-lawsuit"
          element={
            <CaseFormWrapper>
              <FiledLawsuit />
            </CaseFormWrapper>
          }
        />
        <Route
          path="segmentation"
          element={
            <CaseFormWrapper>
              <CaseSegment />
            </CaseFormWrapper>
          }
        />
        <Route
          path={'zoning-plan-compliance'}
          element={
            <CaseFormWrapper>
              <CaseZoningPlanCompliance />
            </CaseFormWrapper>
          }
        />
        <Route
          path={'delivery-order'}
          element={
            <CaseFormWrapper>
              <DeliveryOrder />
            </CaseFormWrapper>
          }
        />
        <Route
          path={'special-regulations-compliance'}
          element={
            <CaseFormWrapper>
              <SpecialRegulationsCompliance />
            </CaseFormWrapper>
          }
        />
        <Route
          path="case-revision"
          element={
            <CaseFormWrapper>
              <CaseRevision />
            </CaseFormWrapper>
          }
        />
        <Route
          path="*"
          element={
            <CaseFormWrapper>
              <CaseTabNotImplemented />
            </CaseFormWrapper>
          }
        />
      </Route>
    </ErrorBoundaryRoutes>
  );
};

const mapStateToProps = ({}: IRootState) => ( {} );

export default connect(mapStateToProps, null)(CasesRoutes);
